import { Component, Input } from '@angular/core';
import { Filter } from '../models/filter-models';
import { ItemDataService } from '../services/item-data.service';
import { BaseComponent } from '../common/base.component';
import { PresetsService } from '../services/presets.service';
import { PresetPreviewService } from '../services/preset-preview.service';

@Component({
  selector: 'app-class-presets',
  imports: [],
  templateUrl: './class-presets.component.html',
  styleUrls: ['./class-presets.component.scss', '../common/preset-preview-shared.scss']
})
export class ClassPresetsComponent extends BaseComponent {
  @Input({ required: true }) filter!: Filter;

  classPresetTexts: { [preset in string]: string };
  classPresetOptions: { key: string; img: string }[];

  constructor(private itemDataService: ItemDataService, public presetsService: PresetsService, private presetPreviewService: PresetPreviewService) {
    super();
    this.classPresetTexts = this.itemDataService.getClassPresetTexts();
    const classNames = this.poe2
      ? ['Warrior', 'Mercenary', 'Ranger', 'Huntress', 'Monk', 'Witch', 'Sorceress', 'Druid']
      : ['Marauder', 'Duelist', 'Ranger', 'Scion', 'Shadow', 'Witch', 'Templar'];
    this.classPresetOptions = classNames.map(key => ({
      key,
      img: `${this.imgPrefix}/img/presets/${key.toLowerCase()}.webp`,
    }));
  }

  setClassPreset(classPreset: string) {
    this.presetPreviewService.initiateClassPresetChange(classPreset);
  }

  previewClassPreset(classPreset: string) {
    this.presetPreviewService.previewClassPresetChange(classPreset);
  }
}
